export default __webpack_public_path__ + "static/media/up7s.2ccfab08.png";